import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate, formatNumber } from '../../utils';

const getTableData = (data, columns) => {
  const headers = columns.map(({ Header }) => Header);
  const rows = [];
  data.forEach(
    ({
      pmcName,
      buildingName,
      unitsCount,
      launchDate,
      monthlyBill,
      totalPerPmc,
      grandTotal,
    }) => {
      rows.push([
        pmcName,
        buildingName,
        unitsCount ? String(unitsCount) : '',
        formatDate(launchDate, true, 'MM/DD/YYYY'),
        monthlyBill ? `$${formatNumber(monthlyBill)}` : '',
        totalPerPmc ? `$${formatNumber(totalPerPmc)}` : '',
        grandTotal ? `$${formatNumber(grandTotal)}` : '',
      ]);
    },
  );
  return { headers, rows };
};

const MonthlyBillExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default MonthlyBillExport;
